import React from 'react';
import {routes} from "../config";
import {Link} from "react-router-dom";


const CallToActionSection = () => (
  <section className={'cta'}>
    <div className={'container'}>
      <p>Ready to build great things?</p>
      <Link to={routes.contact}>Let's talk</Link>
    </div>
  </section>
);

export default CallToActionSection;


// WEBPACK FOOTER //
// ./src/sections/CallToActionSection.js